import React, { useState } from 'react';
import { Menu, X, Phone, ChevronDown } from 'lucide-react';
import { Container } from '../ui/Container';
import { Button } from '../ui/Button';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navLinks = [{
    name: 'Business Cards',
    href: '#business-cards'
  }, {
    name: 'Signage + Install',
    href: '#signage'
  }, {
    name: 'Services',
    href: '#services',
    hasDropdown: true
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className="sticky top-0 z-50 bg-white border-b border-gray-100 shadow-sm" data-id="element-80">
      <Container data-id="element-81">
        <div className="flex justify-between items-center h-20" data-id="element-82">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-83">
            <a href="/" className="flex items-center gap-2" data-id="element-84">
              <img src="https://cdn.magicpatterns.com/uploads/5CDBsMBQVQ2Rdnn2FJqdej/DP_Logo_horizontal650x.png" alt="Digital Printing - Make a Lasting Impression" className="h-10 w-auto" data-id="element-85" />
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-86">
            {navLinks.map(link => <div key={link.name} className="relative group" data-id="element-87">
                <a href={link.href} className="text-gray-600 hover:text-cyan-600 font-medium text-sm flex items-center transition-colors" data-id="element-88">
                  {link.name}
                  {link.hasDropdown && <ChevronDown className="ml-1 h-4 w-4" data-id="element-89" />}
                </a>
              </div>)}
          </nav>

          {/* Desktop CTAs */}
          <div className="hidden md:flex items-center space-x-4" data-id="element-90">
            <a href="tel:0894033306" className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-50 text-gray-600 hover:bg-cyan-50 hover:text-cyan-600 transition-colors" aria-label="Call us on 08 9403 3306" data-id="element-91">
              <Phone className="h-5 w-5" data-id="element-92" />
            </a>
            <Button variant="primary" size="sm" onClick={() => document.getElementById('quote')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-93">
              Get a Quote
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-94">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-500 hover:text-gray-700 p-2" aria-expanded={isMenuOpen} data-id="element-95">
              <span className="sr-only" data-id="element-96">Open main menu</span>
              {isMenuOpen ? <X className="h-6 w-6" data-id="element-97" /> : <Menu className="h-6 w-6" data-id="element-98" />}
            </button>
          </div>
        </div>
      </Container>

      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden bg-white border-t border-gray-100 absolute w-full shadow-lg" data-id="element-99">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-100">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-cyan-600 hover:bg-gray-50" onClick={() => setIsMenuOpen(false)} data-id="element-101">
                {link.name}
              </a>)}
            <div className="mt-4 px-3 space-y-3" data-id="element-102">
              <a href="tel:0894033306" className="flex items-center justify-center py-2 text-cyan-600 font-medium" data-id="element-103">
                <Phone className="h-4 w-4 mr-2" data-id="element-104" />
                08 9403 3306
              </a>
              <Button fullWidth onClick={() => {
            setIsMenuOpen(false);
            document.getElementById('quote')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-105">
                Get a Quote
              </Button>
            </div>
          </div>
        </div>}
    </header>;
}